<!-- File Preview Component -->
<FilePreviewComponent
  v-if="show_file_preview"
  :presigned_url="preview_file_url"
  @close="close_file_preview"
/>

<!-- JOURNAL SECTION -->
<div class="bg-white pb-2 mt-3">
  <h5 class="mb-0 text-dark fs-6">Journal</h5>

  <div class="mt-4 d-flex pe-3">
    <button
      class="btn btn-primary-dark btn-sm text-xxs shadow"
      data-bs-toggle="modal"
      data-bs-target="#create_journal_modal"
    >
      Add Journal
    </button>
  </div>

  <!-- Total Hours -->
  <div class="mt-2 mb-3 px-3">
    <span class="fw-bold text-dark text-xs">Total Hours: {{ total_hours }}</span>
  </div>

  <!-- Journal Accordion -->
  <div v-if="journals.length > 0" class="accordion px-3" id="journalAccordion">
    <div
      v-for="(journal, index) in journals"
      :key="journal.id"
      class="accordion-item mb-2 border-0 rounded-2 shadow-sm"
    >
      <!-- Accordion Header -->
      <h2 class="accordion-header text-primary" :id="'heading' + index">
        <button
          class="accordion-button collapsed text-white text-xxs rounded-top border-0 btn-primary-dark"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="'#collapse' + index"
          aria-expanded="false"
          :aria-controls="'collapse' + index"
        >
          <i class="far fa-calendar-alt me-1 text-white"></i>
          {{ journal.date_created }}
        </button>
      </h2>

      <!-- Accordion Body -->
      <div
        :id="'collapse' + index"
        class="accordion-collapse collapse text-white"
        :aria-labelledby="'heading' + index"
        data-bs-parent="#journalAccordion"
      >
      <div class="text-left p-2 mb-1">
      <button
        class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark"
        data-bs-toggle="modal"
        data-bs-target="#update_journal_modal"
        @click="update_application_journals(journal)"
      >
        Edit Journal
      </button>

      </div>

        <div class="accordion-body card-color p-3 rounded-bottom">
          <!-- User Info -->
          <div class="row mt-1">
            <div class="col-md-12">
              <span class="float-start me-2 text-dark text-xxs">
                <i class="fas fa-user me-1"></i>
                <strong>Created By:</strong>
                {{ journal.user_first_name }} {{ journal.user_last_name }}
              </span>
            </div>
          </div>

          <!-- Hours Spent -->
          <div class="row mt-2">
            <div class="col-md-12">
              <span class="float-start me-2 text-dark text-xxs">
                <i class="fas fa-clock me-1"></i>
                <strong>Hours Spent:</strong>
                {{ journal.hours_spent_display }}
              </span>
            </div>
          </div>

          <!-- Journal Date -->
          <div class="row mt-2">
            <div class="col-md-12 d-flex align-items-center">
              <span class="me-2 text-dark text-xxs">
                <i class="fas fa-calendar-check me-1"></i>
                <strong>Journal Date:</strong>
              </span>
              <span class="submission-date text-xxs">{{ journal.journal_date || "No date" }}</span>
            </div>
          </div>

          <!-- Description -->
          <div class="mt-3">
            <label class="fw-bold text-dark text-xxs mb-1">Description</label>
            <textarea
              class="form-control text-xxs form-control-sm"
              disabled
              rows="3"
            >{{ journal.journal_description }}</textarea>
          </div>

          <!-- Documents -->
          <div class="mt-3">
            <label class="fw-bold text-dark text-xxs mb-1">Attached Documents</label>
            <div>
              <div
                v-if="journal.documents && journal.documents.length > 0"
                class="d-flex flex-wrap"
              >
                <button
                  v-for="doc in journal.documents"
                  :key="doc.id"
                  type="button"
                  @click="view_document(doc)"
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark me-2 mb-2"
                >
                  <i class="fas fa-eye me-1"></i> {{ doc.document_name }}
                </button>
              </div>

              <p v-else class="text-muted text-xxs fst-italic">
                No documents attached.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <p v-else class="text-muted text-xs fst-italic px-3">
    No journals found for this application.
  </p>
</div>
<!-- ===================== END JOURNAL LIST SECTION ===================== -->



<!-- CREATE JOURNAL MODAL -->
<teleport to="body">
<div
  class="modal fade"
  id="create_journal_modal"
  tabindex="-1"
  aria-labelledby="create_journal_modal_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content border-0 shadow-lg">
      <!-- Header -->
      <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
        <h5
          class="modal-title text-white text-xs m-0"
          id="create_journal_modal_label"
        >
          Create Journal
        </h5>
        <button
          type="button"
          class="btn-close modal-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-4">
        <form @submit.prevent="create_journal">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="hours_spent" class="text-xxs fw-bold mb-1">Hours Worked</label>
              <div class="input-group">
                <span class="input-group-text text-xxs bg-light fw-bold">Hours</span>
                <input
                  type="number"
                  class="form-control text-xs"
                  id="add_hours"
                  v-model.number="hours_worked"
                  name="add_hours"
                  placeholder="0"
                  min="0"
                  max="23"
                />
                <span class="input-group-text text-xxs bg-light fw-bold">Minutes</span>
                <input
                  type="number"
                  class="form-control text-xs"
                  id="add_minutes"
                  v-model.number="minutes_worked"
                  name="add_minutes"
                  placeholder="0"
                  min="0"
                  max="59"
                />
              </div>
            </div>

            <!-- Journal Date -->
            <div class="col-md-6 mb-3">
              <label for="journal_date" class="text-xxs fw-bold mb-1">Journal Date</label>
              <div class="input-group">
                <span class="input-group-text text-xxs bg-light fw-bold">Date</span>
                <input
                  v-model="journal_date"
                  type="date"
                  class="form-control text-xs"
                  id="journal_date"
                  name="journal_date"
                />
              </div>
            </div>
          </div>

          <!-- Journal Description -->
          <div class="form-group mb-3">
            <label class="text-xxs fw-bold mb-1">Journal Description</label>
            <textarea
              v-model="journal_description"
              class="form-control text-xs p-2"
              rows="3"
              placeholder="Describe this journal entry..."
              required
            ></textarea>
          </div>

          <!-- Journal Attachments -->
          <div class="form-group mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="text-xxs fw-bold mb-0">Journal Attachments</label>
              <button
                type="button"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="add_attachment"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>

            <!-- Dynamic Attachments -->
            <div
              v-for="(attachment, index) in attachments"
              :key="index"
              class="border rounded p-3 mb-3 position-relative"
            >
              <!-- Remove Button -->
              <button
                type="button"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark position-absolute top-0 end-0 m-2"
                @click="remove_attachment(index)"
              >
                <i class="bi bi-trash-fill"></i>
              </button>

              <!-- Document Name -->
              <div class="mb-2">
                <label class="text-xxs fw-bold">Document Name</label>
                <input
                  type="text"
                  v-model="attachment.document_name"
                  class="form-control text-xs mt-1"
                  placeholder="e.g. Affidavit, Supporting Evidence"
                  required
                />
              </div>

              <!-- Upload File -->
              <div>
                <label class="text-xxs fw-bold">Upload File</label>
                <input
                  type="file"
                  class="form-control text-xs mt-1"
                  @change="handle_file_upload($event, index)"
                  accept=".pdf,.png,.jpg,.jpeg,.docx"
                  required
                />
                <small
                  v-if="attachment.file"
                  class="text-success text-xxs mt-1 d-block"
                >
                  {{ attachment.file.name }}
                </small>
              </div>
            </div>

            <!-- Empty State -->
            <p
              v-if="attachments.length === 0"
              class="text-muted text-xxs mt-2 mb-0 fst-italic"
            >
              No attachments added yet. Click <b>+</b> to add your first file.
            </p>
          </div>

          <!-- Progress or Loading -->
          <div v-if="is_saving_journal" class="alert alert-info text-xs py-1 mb-3">
            Uploading journal and documents, please wait...
          </div>

          <!-- Submit Button -->
          <div class="d-flex justify-content-end mt-3">
            <button
              type="submit"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              :disabled="is_saving_journal"
            >
              <span v-if="!is_saving_journal">Save Journal</span>
              <span v-else>Saving...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Update journal modal -->
 <teleport to="body">
<div
  class="modal fade"
  id="update_journal_modal"
  tabindex="-1"
  aria-labelledby="update_journal_modal_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 shadow-lg">
        <!-- Header -->
        <div
          class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2"
        >
          <h5
            class="modal-title text-white text-xs m-0"
            id="update_journal_modal_label"
          >
            Update Journal
          </h5>
          <button
            type="button"
            class="btn-close modal-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-4 scroll-container">
          <form @submit.prevent="update_journal">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="text-xxs fw-bold mb-1">Hours Worked</label>
                <div class="input-group">
                  <span class="input-group-text text-xxs bg-light fw-bold">Hours</span>
                  <input
                    type="number"
                    class="form-control text-xs"
                    v-model.number="edit_hours"
                    min="0"
                    max="23"
                  />
                  <span class="input-group-text text-xxs bg-light fw-bold">Minutes</span>
                  <input
                    type="number"
                    class="form-control text-xs"
                    v-model.number="edit_minutes"
                    min="0"
                    max="59"
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-xxs fw-bold mb-1">Journal Date</label>
                <div class="input-group">
                  <span class="input-group-text text-xxs bg-light fw-bold">Date</span>
                  <input
                    v-model="edit_journal_date"
                    type="date"
                    class="form-control text-xs"
                  />
                </div>
              </div>
            </div>

            <!-- Journal Description -->
            <div class="form-group mb-3">
              <label class="text-xxs fw-bold mb-1">Journal Description</label>
              <textarea
                v-model="edit_description"
                class="form-control text-xs p-2"
                rows="3"
                required
              ></textarea>
            </div>

            <!-- Inline Editable Documents -->
            <div class="document-list mt-3">
              <label class="fw-bold text-dark text-xxs mb-2">Existing Documents</label>

              <div class="">
                <div
                  v-for="(doc, index) in edit_existing_docs"
                  :key="doc.id"
                  class="border rounded p-3 mb-3 bg-light position-relative shadow-sm"
                >
                  <!-- View Button -->
                  <button
                    type="button"
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow position-absolute top-0 end-0 m-2"
                    @click="view_document(doc)"
                  >
                    <i class="fas fa-eye me-1"></i> View
                  </button>

                  <!-- Document Name -->
                  <div class="mb-2">
                    <label class="text-xxs fw-bold">Document Name</label>
                    <input
                      type="text"
                      v-model="doc.document_name"
                      class="form-control text-xs mt-1"
                      placeholder="e.g. Affidavit, Supporting Evidence"
                      @input="mark_doc_as_updated(doc)"
                    />
                  </div>

                  <!-- Replace File -->
                  <div>
                    <label class="text-xxs fw-bold">Replace File</label>
                    <input
                      type="file"
                      class="form-control text-xs mt-1"
                      @change="handle_replace_file($event, doc)"
                      accept=".pdf,.png,.jpg,.jpeg,.docx"
                    />
                    <small
                      v-if="doc.new_file"
                      class="text-success text-xxs mt-1 d-block"
                    >
                      Selected file: {{ doc.new_file.name }}
                    </small>
                    <small
                      v-else
                      class="text-muted text-xxs mt-1 fst-italic"
                    >
                      Current file: {{ doc.document_name }}
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Add New Attachments -->
            <div class="form-group mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="text-xxs fw-bold mb-0">Add New Attachments</label>
                <button
                  type="button"
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="add_update_attachment"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>

              <div
                v-for="(file, index) in edit_attachments"
                :key="index"
                class="border rounded p-3 mb-3"
              >
                <label class="text-xxs fw-bold">Document Name</label>
                <input
                  type="text"
                  v-model="file.document_name"
                  class="form-control text-xs mb-2"
                  placeholder="e.g. Affidavit"
                />
                <label class="text-xxs fw-bold">Upload File</label>
                <input
                  type="file"
                  class="form-control text-xs"
                  @change="handle_update_file_upload($event, index)"
                />
              </div>
            </div>

            <div class="d-flex justify-content-end mt-3">
              <button
                type="submit"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              >
                Update Journal
              </button>
            </div>
          </form>
        </div>
      </div>
  </div>
</div>
</teleport>



